import React from 'react';
import styles from './Countdown.module.scss';

const Counter = ({number, text, hideOnMobile = false}) => {
    return (
        <div className={`${hideOnMobile ? styles.hideOnMobile : ''}`}>
            <p className={styles.number}>{number}</p>
            <span className={styles.label}>{text}</span>
        </div>
    )
}

export default Counter;